import React, {useEffect, useState} from "react";
import Api from "../../Api/api";
import {toast} from "react-toastify";
import {RiArrowDownSFill, RiArrowUpSFill} from "react-icons/ri";
import {ClipLoader} from "react-spinners";
import UpsellingTable from "./partial/upsellingTable";
import {useStateValue} from "../../states/StateProvider";
import {AES, enc} from "crypto-js";
import {UpsellingHeadersDGG} from "../../staticData/upsellingHeadersDGG";
import Pagination from "../../components/pagination";
import ExcelExportUpselling from "../firmenprojekte/partial/excelFormatUpselling";
import SmartTooltip from "../../components/SmartTooltip";

const Upselling = () => {

    const searchableFields = [0, 1, 2]
    const dropdownsearchFields = [3, 4, 5, 6, 7, 8, 9]
    const sortableFields = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
    const [loading, setLoading] = useState(true)
    const [options, setOptions] = useState([])
    const [data, setData] = useState([])
    const [headers, setHeaders] = useState([])
    const [{
        sortColumnUpselling, sortMethodUpselling, secretKey, portal, filterUpselling, filterIDUpselling, pageUpselling
    }, dispatch] = useStateValue();
    const [superAdmin, setSuperAdmin] = useState('')

    const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
    const user = JSON.parse(decryptedBytes.toString(enc.Utf8))
    const userID = user.ID
    const url = 'sp_getDataUpselling/dgg/' + userID
    const urlGesamt = 'sp_getDataUpsellingAll/dgg/' + userID
    const count = UpsellingHeadersDGG.length - 2


    const [rows, setRows] = useState('10');
    const [total, setTotal] = useState(0);
    let PageSize = rows;

    useEffect(() => {
        const delayQuery = setTimeout(async () => {
            setLoading(true)
            setData([])
            if (portal) {
                if (portal === 'dgg') {
                    setHeaders(UpsellingHeadersDGG)
                } else if (portal === 'ruv') {
                    setHeaders(UpsellingHeadersDGG)
                }

                const Data = new FormData()
                Data.append('perPage', rows)
                Data.append('page', pageUpselling)
                Data.append('sort', sortColumnUpselling)
                Data.append('sortMethod', sortMethodUpselling)
                Data.append('filter', JSON.stringify(filterUpselling))
                Data.append('filterID', JSON.stringify(filterIDUpselling))

                try {
                    Api().post(`sp_getDataUpselling/dgg/${userID}`, Data).then(res => {
                        setData(res.data)
                        setTotal(res.data[0]?.total)
                        setLoading(false)
                    }).catch(e => {
                        toast.error('Etwas ist schief gelaufen!!')
                        setLoading(false)
                    })

                } catch (e) {
                    window.location.replace('/anmeldung')
                }
            }
        }, filterUpselling ? 1500 : 0)

        Api().get(`sp_getUpsellingOptions/${'dgg'}`)
            .then(res => {
                setOptions(res.data)
            })

        return () => clearTimeout(delayQuery)

    }, [rows, portal, pageUpselling, sortMethodUpselling, sortColumnUpselling, filterIDUpselling, filterUpselling]);

    useEffect(() => {
        setSuperAdmin(user.isSAdmin)
        if ((user.role === 'ExtDGG' || user.role === 'ManDGG')) {
            dispatch({type: 'SET_PORTAL', item: 'dgg'})
            localStorage.setItem('portal', 'dgg')
        } else if ((user.role === 'ExtRUV' || user.role === 'ManRUV')) {
            dispatch({type: 'SET_PORTAL', item: 'ruv'})
            localStorage.setItem('portal', 'ruv')
        } else {
            if (localStorage.getItem('portal')) {
                dispatch({type: 'SET_PORTAL', item: localStorage.getItem('portal')})
            } else {
                dispatch({type: 'SET_PORTAL', item: 'dgg'})
            }
        }
    }, []);

    function portalSelect(e) {
        dispatch({type: 'SET_PORTAL', item: e.target.value})
        localStorage.setItem('portal', e.target.value)
    }

    function ascSort(id) {
        dispatch({type: "SET_SORT_COLUMN_UPSELLING", item: id})
        dispatch({type: "SET_SORT_UPSELLING_METHOD", item: 'asc'})
    }

    function descSort(id) {
        dispatch({type: "SET_SORT_COLUMN_UPSELLING", item: id})
        dispatch({type: "SET_SORT_UPSELLING_METHOD", item: 'desc'})
    }

    function setPageStates(e) {
        dispatch({type: "SET_PAGE_UPSELLING", item: 1})
        setRows(e.target.value)
    }

    function enableFilter(type, id, val) {

        if (id === 1) {
            dispatch({type: "SET_SORT_UPSELLING_FILTER", item: {...filterUpselling, a: val}})
            dispatch({type: "SET_SORT_UPSELLING_FILTER_ID", item: {...filterIDUpselling, a: 1}})
        }
        if (id === 2) {
            dispatch({type: "SET_SORT_UPSELLING_FILTER", item: {...filterUpselling, b: val}})
            dispatch({type: "SET_SORT_UPSELLING_FILTER_ID", item: {...filterIDUpselling, b: 2}})
        }
        if (id === 3) {
            dispatch({type: "SET_SORT_UPSELLING_FILTER", item: {...filterUpselling, c: val}})
            dispatch({type: "SET_SORT_UPSELLING_FILTER_ID", item: {...filterIDUpselling, c: 3}})
        }
        if (id === 4) {
            dispatch({type: "SET_SORT_UPSELLING_FILTER", item: {...filterUpselling, d: val}})
            dispatch({type: "SET_SORT_UPSELLING_FILTER_ID", item: {...filterIDUpselling, d: 4}})
        }
        if (id === 5) {
            dispatch({type: "SET_SORT_UPSELLING_FILTER", item: {...filterUpselling, e: val}})
            dispatch({type: "SET_SORT_UPSELLING_FILTER_ID", item: {...filterIDUpselling, e: 5}})
        }
        if (id === 6) {
            dispatch({type: "SET_SORT_UPSELLING_FILTER", item: {...filterUpselling, f: val}})
            dispatch({type: "SET_SORT_UPSELLING_FILTER_ID", item: {...filterIDUpselling, f: 6}})
        }
        if (id === 7) {
            dispatch({type: "SET_SORT_UPSELLING_FILTER", item: {...filterUpselling, g: val}})
            dispatch({type: "SET_SORT_UPSELLING_FILTER_ID", item: {...filterIDUpselling, g: 7}})
        }
        if (id === 111) {
            dispatch({type: "SET_SORT_UPSELLING_FILTER", item: {...filterUpselling, h: val}})
            dispatch({type: "SET_SORT_UPSELLING_FILTER_ID", item: {...filterIDUpselling, h: 111}})
        }
        if (id === 112) {
            dispatch({type: "SET_SORT_UPSELLING_FILTER", item: {...filterUpselling, i: val}})
            dispatch({type: "SET_SORT_UPSELLING_FILTER_ID", item: {...filterIDUpselling, i: 112}})
        }
        if (id === 113) {
            dispatch({type: "SET_SORT_UPSELLING_FILTER", item: {...filterUpselling, j: val}})
            dispatch({type: "SET_SORT_UPSELLING_FILTER_ID", item: {...filterIDUpselling, j: 113}})
        }
    }

    const [hasFilter, setHasFilter] = useState(false);

    useEffect(() => {
        const keys = Object.keys(filterUpselling);
        const keysToRestore = keys.slice(-3);
        const valuesToRestore = keysToRestore.map(key => ({[key]: filterUpselling[key]}));
        keysToRestore.forEach(key => delete filterUpselling[key]);
        const isNullUndefEmptyStr = Object.values(filterUpselling).every(value => {
            return value === null || value === undefined || value === '';
        });
        if (isNullUndefEmptyStr) {
            setHasFilter(true)
        } else {
            setHasFilter(false)
        }
        valuesToRestore.forEach(valueObj => {
            const key = Object.keys(valueObj)[0];
            filterUpselling[key] = valueObj[key];
        });
    }, [filterUpselling]);

    function clearFilters() {
        dispatch({
            type: "SET_SORT_UPSELLING_FILTER",
            item: {a: null, b: null, c: null, d: null, e: null, f: null, g: null, h: null, i: null, j: null}
        })
        dispatch({
            type: "SET_SORT_UPSELLING_FILTER_ID",
            item: {a: null, b: null, c: null, d: null, e: null, f: null, g: null, h: null, i: null, j: null}
        })
    }

    const loadingText = loading ? <>Daten werden geladen ...</> : <>Aktuell liegen keine Firmen mit Dienstleistungs-Prozessen vor.</>;


    const getIconForValue = (value) => {
        const match = options.find(op => op.title === value);
        return match && match.icon ? `${window.location.origin}/icons/${match.icon}` : null;
    };


    return (<div className='dashboardContainer'>
        <div className='flex justify-start items-center content-center pb-5'>
            <h2 className='text-2xl lg:text-left'> Dienstleistungen</h2>
        </div>
        <div className="flex flex-col p-10 pt-5 bg-white">
            <div className="bg-white pt-3 pb-1 px-3 flex flex-col lg:flex-row lg:justify-between lg:items-start gap-4">
                {/* Left: Excel Export buttons */}
                <div className="flex flex-wrap gap-3">
                    <ExcelExportUpselling
                        all
                        url={url}
                        count={count}
                        rows={rows}
                        title="Excel Export"
                        loading={loading}
                        len={data?.length}
                    />
                    <ExcelExportUpselling
                        Gesamt
                        url={urlGesamt}
                        count={count}
                        rows={rows}
                        title="Excel Export Gesamt"
                        loading={loading}
                        len={data?.length}
                    />
                </div>

                <div className="flex flex-wrap items-center gap-4 text-sm text-grey">
                    <span className="font-semibold text-grey">Legende:</span>
                    {options
                        .filter(opt => opt.title !== '--' && opt.icon)
                        .map(opt => (
                            <div key={opt.ID} className="flex items-center gap-1">
                                <img
                                    src={`${window.location.origin}/icons/${opt.icon}`}
                                    alt={opt.title}
                                    className="w-5 h-5"
                                />
                                <span className="text-xs">{opt.title}</span>
                            </div>
                        ))
                    }
                    <div className="flex items-center gap-1 text-xs">|</div>
                    <div className="flex items-center gap-1 text-xs">Umsetzungsquote in %</div>
                </div>
            </div>
            <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="pt-1">
                        {(data?.length === 0) && <div className='centerItemsAbsolute'>
                            <h2 className='text-2xl text-text font-bold'>
                                {loadingText}
                            </h2>
                            {loading && <div className='mt-4'><ClipLoader size={50} color={'#b4b4b4'}/></div>}
                        </div>}
                        <button disabled={hasFilter} onClick={clearFilters}
                                className={`${hasFilter && 'hideDiv bg-white text-text'} ${loading ? 'hideDiv' : ''} mx-auto mb-5 justify-center w-52 rounded-md border border-offWhite shadow-sm px-4 opacity-80 py-2 bg-cancel text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
                        >
                            {!hasFilter ? 'Such-Filter zurücksetzen' : 'Kein Suche Filter'}
                        </button>
                        <div className='table-wrp block' style={{maxHeight: '60vh'}}>
                            <table className='min-w-full text-left bg-white'>
                                <thead
                                    className="whitespace-nowrap bg-white border-y border-silver border-x-0 sticky top-0">
                                <tr>
                                    {!loading && headers?.map(header => (
                                        <SmartTooltip
                                            key={header.id}
                                            content={header.mouseOver}
                                            placement="auto"
                                            maxWidth={320}
                                        >
                                            <th scope="col" className={`text-sm text-grey pl-1.5`}>
                                                <span className='flex justify-left'>
                                                    <span
                                                        className={`mt-1.5 text-center xl:h-fit lg:h-14 ${sortColumnUpselling === header.id && 'text-mainBlue'}`}
                                                    >
                                                        {header.title}
                                                    </span>
                                                    <span
                                                        className={`${!(sortableFields.includes(header.id)) && 'opacity-0'}`}>
                                                        <p className={`cursor-pointer ${sortColumnUpselling === header.id && sortMethodUpselling === 'asc' ? 'text-mainBlue' : ''}`}
                                                           onClick={() => ascSort(header.id)}
                                                        >
                                                            <RiArrowUpSFill size='22px'/>
                                                        </p>
                                                        <p className={`-mt-3.5 cursor-pointer ${sortColumnUpselling === header.id && sortMethodUpselling === 'desc' ? 'text-mainBlue' : ''}`}
                                                           onClick={() => descSort(header.id)}
                                                        >
                                                            <RiArrowDownSFill size='22px'/>
                                                        </p>
                                                    </span>
                                                </span>
                                                <span
                                                    className={`${!(searchableFields.includes(header.id)) && 'hideDiv'}`}>
                                                    <input
                                                        className={`h-8 px-2 py-3 search mb-7 ${header.id === 1 ? 'w-96' : 'w-32'}`}
                                                        type='text'
                                                        maxLength="50"
                                                        value={header.id === 1 ? filterUpselling.a : header.id === 2 && filterUpselling.b}
                                                        onChange={(e) => enableFilter('text', header.id, e.target.value)}
                                                        placeholder='Suche...'
                                                    />
                                                </span>
                                                <span
                                                    className={`${!(dropdownsearchFields.includes(header.id)) && 'hideDiv'}`}>
                                                   <select
                                                       value={header.id === 3 ? filterUpselling.c : header.id === 4 ? filterUpselling.d : header.id === 5 ? filterUpselling.e : header.id === 6 ? filterUpselling.f : header.id === 7 ? filterUpselling.g : header.id === 8 ? filterUpselling.h : filterUpselling.i}
                                                       onChange={(e) => enableFilter('dropdown', header.id, e.target.value)}
                                                       className={`px-4 text-xs py-2 search rounded-md bg-white cursor-pointer mb-7 ${(header.id === 3 ? filterUpselling.c : header.id === 4 ? filterUpselling.d : header.id === 5 ? filterUpselling.e : header.id === 6 ? filterUpselling.f : header.id === 7 ? filterUpselling.g : header.id === 8 ? filterUpselling.h : filterUpselling.i) == null || (header.id === 3 ? filterUpselling.c : header.id === 4 ? filterUpselling.d : header.id === 5 ? filterUpselling.e : header.id === 6 ? filterUpselling.f : header.id === 7 ? filterUpselling.g : header.id === 8 ? filterUpselling.h : filterUpselling.i) === '' || (header.id === 3 ? filterUpselling.c : header.id === 4 ? filterUpselling.d : header.id === 5 ? filterUpselling.e : header.id === 6 ? filterUpselling.f : header.id === 7 ? filterUpselling.g : header.id === 8 ? filterUpselling.h : filterUpselling.i) == null || (header.id === 3 ? filterUpselling.c : header.id === 4 ? filterUpselling.d : header.id === 5 ? filterUpselling.e : header.id === 6 ? filterUpselling.f : header.id === 7 ? filterUpselling.g : header.id === 8 ? filterUpselling.h : filterUpselling.i) === 'kein Interesse' ? 'text-placeholder' : 'text-mainBlue'}`}
                                                   >
                                                      <option className='text-placeholder' value="">Alle</option>
                                                       {options?.map(op => (
                                                           <option className='text-text' key={op.ID} value={op.title}>
                                                               <img src={`${window.location.origin}/icons/${op.icon}`}/>
                                                               <span className='ml-2'>{op.title}</span>
                                                           </option>))}
                                                    </select>
                                                </span>
                                                <br/>
                                            </th>
                                        </SmartTooltip>
                                    ))}
                                    {/*<th scope="col" className="text-sm w-1/12 text-grey px-2"/>*/}
                                </tr>
                                </thead>
                                <tbody>
                                {data?.map((u) => {
                                    let hoverTextBav, hoverTextCls, hoverTextGE, hoverTextHRMT, hoverTextUpselling, hoverTextBbu,
                                        hoverTextBkv;
                                    let bavValue, clsValue, geValue, hrmtValue, upsellingValue, bbuValue, bkvValue;
                                    let bavValueIcon, clsValueIcon, geValueIcon, hrmtValueIcon, upsellingValueIcon, bbuValueIcon, bkvValueIcon;
                                    let valueBavDurch = '0,0';
                                    let valueGEDurch = '0,0';
                                    const keyBav = Object.keys(u).find(k => k.startsWith('bAV-'));
                                    const keyBavDurch = Object.keys(u).find(k => k.startsWith('bAV_Przt-Durchdringung'));
                                    if (keyBav) {
                                        bavValue = u[keyBav];
                                        bavValueIcon = bavValue;
                                        if(keyBavDurch) {
                                            valueBavDurch = (u[keyBavDurch]*100).toFixed(1).replace('.', ',');
                                            if(valueBavDurch !== '0,0') {
                                                bavValue += ' ' + valueBavDurch + '%';
                                            }
                                        }
                                        const [firstPartBav, secondPartBav] = keyBav.split('-');
                                        hoverTextBav = secondPartBav.replace('_', ' ');
                                    }

                                    const keyGE = Object.keys(u).find(k => k.startsWith('GE-'));
                                    const keyGEDurch = Object.keys(u).find(k => k.startsWith('GE_Przt-Durchdringung'));
                                    if (keyGE) {
                                        geValue = u[keyGE];
                                        geValueIcon = geValue;
                                        if(keyGEDurch) {
                                            valueGEDurch = (u[keyGEDurch]*100).toFixed(1).replace('.', ',');
                                            if(valueGEDurch !== '0,0') {
                                                geValue += ' ' + valueGEDurch + '%';
                                            }
                                        }
                                        const [firstPartGE, secondPartGE] = keyGE.split('-');
                                        hoverTextGE = secondPartGE.replace('_', ' ');
                                    }

                                    const keyHRMT = Object.keys(u).find(k => k.startsWith('HRMT-'));
                                    if (keyHRMT) {
                                        hrmtValue = u[keyHRMT];
                                        const [firstPartHRTM, secondPartHRMT] = keyHRMT.split('-');
                                        hoverTextHRMT = secondPartHRMT.replace('_', ' ');
                                    }

                                    const keyUpselling = Object.keys(u).find(k => k.startsWith('Upselling-'));
                                    if (keyUpselling) {
                                        upsellingValue = u[keyUpselling];
                                        const [firstPartUpselling, secondPartUpselling] = keyUpselling.split('-');
                                        hoverTextUpselling = secondPartUpselling.replace('_', ' ');
                                    }

                                    const keybBU = Object.keys(u).find(k => k.startsWith('bBU-'));
                                    if (keybBU) {
                                        bbuValue = u[keybBU];
                                        const [firstPartBbu, secondPartBbu] = keybBU.split('-');
                                        hoverTextBbu = secondPartBbu.replace('_', ' ');
                                    }

                                    const keybkv = Object.keys(u).find(k => k.startsWith('bKV-'));
                                    if (keybkv) {
                                        bkvValue = u[keybkv];
                                        const [firstPartBkv, secondPartBkv] = keybkv.split('-');
                                        hoverTextBkv = secondPartBkv.replace('_', ' ');
                                    }

                                    const keycls = Object.keys(u).find(k => k.startsWith('CLS-'));
                                    if (keycls) {
                                        clsValue = u[keycls];
                                        const [firstPartCls, secondPartCls] = keycls.split('-');
                                        hoverTextCls = secondPartCls.replace('_', ' ');
                                    }

                                    return (<UpsellingTable
                                        key={u.FP_ID}
                                        FirmaID={u.FP_ID}
                                        portal={portal}
                                        Firma={u.Firma}
                                        Closer={u.Closer}
                                        bav={
                                            getIconForValue(bavValueIcon)
                                                ? (
                                                    <>
                                                        <img
                                                            src={getIconForValue(bavValueIcon)}
                                                            alt={bavValue}
                                                            className="w-5 h-5 inline-block"
                                                            title={bavValue}
                                                        />
                                                        {valueBavDurch !== '0,0' ? ` ${valueBavDurch}%` : ''}
                                                    </>
                                                )
                                                : bavValue
                                        }
                                        bavHover={hoverTextBav}
                                        bkv={
                                            getIconForValue(bkvValue)
                                                ? <img src={getIconForValue(bkvValue)} alt={bkvValue} className="w-5 h-5 inline-block" title={bkvValue} />
                                                : bkvValue
                                        }
                                        bkvHover={hoverTextBkv}
                                        GehaltsExtras={
                                            getIconForValue(geValueIcon)
                                                ? (
                                                    <>
                                                        <img
                                                            src={getIconForValue(geValueIcon)}
                                                            alt={geValue}
                                                            className="w-5 h-5 inline-block"
                                                            title={geValue}
                                                        />
                                                        {valueGEDurch !== '0,0' ? ` ${valueGEDurch}%` : ''}
                                                    </>
                                                )
                                                : geValue
                                        }
                                        GehaltsExtrasHover={hoverTextGE}
                                        CLS={
                                            getIconForValue(clsValue)
                                                ? <img src={getIconForValue(clsValue)} alt={clsValue} className="w-5 h-5 inline-block" title={clsValue} />
                                                : clsValue
                                        }
                                        HRMT={
                                            getIconForValue(hrmtValue)
                                                ? <img src={getIconForValue(hrmtValue)} alt={hrmtValue} className="w-5 h-5 inline-block" title={hrmtValue} />
                                                : hrmtValue
                                        }
                                        HRMTHover={hoverTextHRMT}
                                        // NBG={u.NBG}
                                        bbu={
                                            getIconForValue(bbuValue)
                                                ? <img src={getIconForValue(bbuValue)} alt={bbuValue} className="w-5 h-5 inline-block" title={bbuValue} />
                                                : bbuValue
                                        }
                                        bbuHover={hoverTextBbu}
                                        sortColumn={sortColumnUpselling}
                                        sortMethod={sortMethodUpselling}
                                    />)
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`grid grid-cols-3 items-center ${loading && 'opacity-0'}`}>
                <div className="col-span-1 flex gap-10">
                    <p className={`${(data?.length === 0) && 'hideDiv'} mr-2 text-sm text-grey mt-11`}>
                        {pageUpselling === 1 ? pageUpselling : (1 + (Number(rows) * pageUpselling)) - Number(rows)} bis {(data?.length < Number(rows)) ? data.length + Number(rows) < total ? data.length + (Number(rows) * pageUpselling) - Number(rows) : total : (Number(rows) + (Number(rows) * pageUpselling)) - Number(rows)} von {total} Einträge
                    </p>
                    <h2 className={`${(data?.length === 0) && 'hideDiv'}  text-sm text-grey mt-11`}>
                        Einträge anzeigen:
                        <span>
                            <select onChange={setPageStates} className={` bg-transparent text-mainBlue`}>
                                <option value={'10'}>{10}</option>
                                <option value={'25'}>{25}</option>
                                <option value={'10000'}>Alle</option>
                            </select>
                        </span>
                    </h2>
                </div>
                <div className="flex justify-center mt-10">
                    {data.length > 0 && <Pagination
                        className="pagination-bar"
                        currentPage={pageUpselling}
                        totalCount={total}
                        pageSize={PageSize}
                        onPageChange={pageNo => dispatch({
                            type: "SET_PAGE_UPSELLING", item: pageNo
                        })}
                    />}
                </div>
            </div>
        </div>
    </div>)
}

export default Upselling
